import Cookie from '../utils/cookie';

function showLog(): boolean {
    return Cookie.get('showLog') === '1';
}

function isLocalSystem(): boolean {
    return /127.0.0.1:3100/.test(window.location.href);
}

function getVersion1Url(href: string): string {
    href = href.replace(/&useStageCore/, '');
    href = href.replace(/&useBad/, '');
    href += '&useBad';

    return href;
}

function getVersion2Url(href: string): string {
    href = href.replace(/&useStageCore/, '');
    href = href.replace(/&useBad/, '');
    href += '&useStageCore';

    return href;
}

export {
    showLog,
    isLocalSystem,
    getVersion1Url,
    getVersion2Url
};
